import LegalLayout from "./LegalLayout";

export function ContactUsContent() {
    return (
        <div>
            <p>本网站上任何内容（包括但不限于文字、图片、音频、视频、页面设计、编排、UI及软件等）均受国家法律及国际条约版权保护。除非法律另有规定，未经月迁事先明确书面许可，对于本网站上的任何内容，任何人不得复制、转载、演绎、镜像或以其他任何方式进行使用。</p>
            <p>本网站上包含的标识、商标、商号和logo等均系月迁或其合作伙伴的受法律保护的商标或其它权益，未经月迁事先明确书面许可，任何人不得擅自使用。</p>
            <p>凡侵犯月迁知识产权及其他合法权益的，月迁均保留追究其法律责任的权利。</p>
            <p>联系邮箱：shilejiasuo@lunar-ring.com</p>
        </div>
    );
}

export default function ContactUsPage({isMusicOn, onMusicToggle, mobile = false}) {
    return <LegalLayout title="联系我们" showDates={false} isMusicOn={isMusicOn} onMusicToggle={onMusicToggle} mobile={mobile}><ContactUsContent/></LegalLayout>;
}
